export default __webpack_public_path__ + "static/media/joloda.373fc989.png";